import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload'

const resourceName = 'regulationautoimage'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (id, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)
const Search = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const DownloadImages = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}/images`, config)
const DownloadImagesByImageType = (id, imageTypeMnemonic, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}/imagetype/${imageTypeMnemonic}/download`, config)
const Upload = (id, imageTypeMnemonic, data = {}, config = {}) => APIClientUpload.post(`${APIRegAuto}/${resourceName}/regulationauto/${id}/imagetype/${imageTypeMnemonic}/upload`, data, config)

const GetImageByMnemonic = (id, imageTypeMnemonic, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}/imagetype/${imageTypeMnemonic}`, config)

const RegulationAutoImageRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Update,
  Delete,
  Search,
  DownloadImages,
  Upload,
  GetImageByMnemonic,
  DownloadImagesByImageType
}

export default RegulationAutoImageRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautoimage.js